import classnames from 'classnames';
import React from 'react';
import { ProductionTimeTooltip } from 'swag-client-common/components/partials/production-time-tooltip';
import { pluralize } from 'swag-common/utils/strings';
import classes from '../cart-item/cart-item.scss';
export const ProductionTime = ({
  isProductionTimeClickable,
  isSelectingProductionTimeDisabled,
  handleOnProductionTimeClick,
  time,
  shouldShowProductionTimeTooltip,
  name,
  className
}) => {
  const handleProductionTimeChangeClick = e => {
    if (!isSelectingProductionTimeDisabled) {
      handleOnProductionTimeClick(e);
    }
  };
  return /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.productionTimeSection, className)
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.productionTimeWrapper, {
      [classes.clickable]: isProductionTimeClickable,
      [classes.disabled]: isSelectingProductionTimeDisabled
    }),
    onClick: handleProductionTimeChangeClick
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.secondaryTitle
  }, "Production Time:"), /*#__PURE__*/React.createElement("span", {
    className: classes.productionTime
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.productionTimeName
  }, name, " -"), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.prodPricePink, classes.withoutPadding, {
      [classes.disabled]: isSelectingProductionTimeDisabled
    }),
    "data-button": "ProductionTime"
  }, isFinite(time) ? pluralize(time, 'Business Day', 's') : 'Default Business Days'), !isSelectingProductionTimeDisabled && /*#__PURE__*/React.createElement("span", {
    className: classes.pencil
  }), shouldShowProductionTimeTooltip && /*#__PURE__*/React.createElement(ProductionTimeTooltip, {
    infoWrapperClassName: classes.productionTimeInfoWrapper
  }))));
};